import { WSButton } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { useQueryFeatureFlags } from "@hooks/useQueryFeatureFlags";
import { addIndefiniteArticleToWord } from "../../../../../shared/utils/addIndefiniteArticleToWord";
import { useGoToBulkReviewRequirements } from "../../../../BulkReview/paths";
import { PayeeFilterRequirementStatus } from "../../../../Payees/routes/RoutePayees/filters/types";
import { getRequirementDefinitionName } from "../../../../RequirementDefinitions/utils";
import { useGoToDashboardPayeeRequirementDetails } from "../../../routes/RouteRequirementDetails/RoutePayeeRequirementDetails";
import { NotificationTemplate } from "../index";
import { RequirementNotificationContext } from "../types";

export type RequirementToApproveContext = RequirementNotificationContext;

const GROUP_THRESHOLD = 2;

export const RequirementPendingReviewClient: NotificationTemplate<RequirementToApproveContext> =
  {
    renderTitle: props =>
      props.group.length >= GROUP_THRESHOLD
        ? "Multiple reviews required"
        : "Review is required",
    renderBody: props => (
      <>
        {props.group.length >= GROUP_THRESHOLD ? (
          `${props.group.length} contractor requirements require your approval.`
        ) : (
          <>
            The contractor submitted{" "}
            {addIndefiniteArticleToWord(
              getRequirementDefinitionName({
                type: props.context.requirement.requirementType,
                ...props.context.requirement.dataSourceMetadata
              })
            )}{" "}
            requirement for your approval. Review the submission and take
            action.
          </>
        )}
      </>
    ),
    Footer: props => {
      const history = useHistory();

      const goToPayeeRequirementDetails =
        useGoToDashboardPayeeRequirementDetails();
      const goToBulkReviewRequirements = useGoToBulkReviewRequirements();

      const queryFeatureFlags = useQueryFeatureFlags();

      if (props.group.length >= GROUP_THRESHOLD) {
        return (
          <WSButton.Link
            size="S"
            rightIcon="chevron-right"
            onClick={() => {
              if (queryFeatureFlags.data?.requirementsBulkReview) {
                goToBulkReviewRequirements({
                  filter: {
                    status: PayeeFilterRequirementStatus.PendingApproval
                  }
                });
                return;
              }

              history.push("/member/dashboard/client-pending-review");
            }}
          >
            View requirements
          </WSButton.Link>
        );
      } else {
        return (
          <WSButton.Link
            size="S"
            rightIcon="chevron-right"
            onClick={() => {
              goToPayeeRequirementDetails({
                requirementId: props?.context?.requirement?.requirementId,
                payeeId: props?.context?.payee?.payeeId
              });
            }}
          >
            View requirement
          </WSButton.Link>
        );
      }
    }
  };
